import { API_CONFIG } from '../config/api';

/**
 * Helper function to make authenticated API calls with automatic logout on 401
 * @param {string} url - API endpoint
 * @param {Object} options - Fetch options
 * @param {Function} onUnauthorized - Callback when 401 is received
 * @returns {Promise<Response>}
 */
export const authenticatedFetch = async (url, options = {}, onUnauthorized = null) => {
  const token = localStorage.getItem('adminToken');
  
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const response = await fetch(`${API_CONFIG.baseURL}${url}`, {
    ...options,
    headers,
  });
  
  // Auto logout on 401 Unauthorized
  if (response.status === 401) {
    localStorage.removeItem('adminToken');
    
    // Call custom handler if provided
    if (onUnauthorized) {
      onUnauthorized();
    } else {
      // Default: redirect to login
      if (window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    
    // Return error response
    return {
      ...response,
      ok: false,
      status: 401,
      statusText: 'Unauthorized'
    };
  }
  
  return response;
};

/**
 * Parse JSON response with error handling
 */
export const parseJsonResponse = async (response) => {
  try {
    const data = await response.json();
    return { response, data };
  } catch (error) {
    return { response, data: null, error: 'Failed to parse response' };
  }
};




